import { Helmet } from 'react-helmet'
import { Button } from 'components/common'
import PriceAndInventory from 'components/functionAndjobs/priceAndInventory'
import { createFtpJob } from 'utils/api/functionAndJobApi'
import toast from 'react-hot-toast'
import { useState } from 'react'
import { AxiosError } from 'axios'
import { ERROR_CODES } from 'utils/constants'

const FunctionAndJobs = () => {
  const [loading, setLoading] = useState(false)

  const handleRunJob = async () => {
    const loadingToast = toast.loading('Initializing FTP Creation', {
      duration: Infinity,
    })
    setLoading(true)
    try {
      await createFtpJob()
      toast.success('FTP Creation Job Initiated', {
        id: loadingToast,
        duration: 3000,
      })
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error?.response?.data?.errors?.msg?.runningService) {
          return toast.error(error.response.data.errors.msg.runningService, {
            id: loadingToast,
            duration: 3000,
          })
        }

        const msg = error?.response?.data?.errors?.msg

        if (msg === ERROR_CODES.FTP_ALREADY_RUNNING) {
          return toast.error('FTP generation is already in progress', {
            id: loadingToast,
            duration: 3000,
          })
        }
      }
      toast.error('Error initiating FTP Creation Job,', {
        id: loadingToast,
        duration: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Helmet>
        <title>ORMS Function & Jobs</title>
      </Helmet>

      <div>
        <h3 className="title">Generate New FTP Files</h3>

        {/* Run Job */}
        <section className="mb-5 mt-3 inline-flex items-center gap-3">
          <Button
            buttonText="Run Job"
            className="w-40"
            type="button"
            onClick={handleRunJob}
            disabled={loading}
          />

          {/* Success Message */}
          {/* <div className="inline-flex w-40 items-center gap-1 rounded-md border-transparent bg-green-light px-2.5 py-2 text-center text-sm font-bold text-green-darker">
            <span className="flex-shrink-0 w-4 h-4">
              <CheckBoxIcon />
            </span>
            <span className="flex-1">Success!</span>
          </div> */}
        </section>

        {/* Price and Inventory  */}
        <PriceAndInventory />
      </div>
    </>
  )
}

export default FunctionAndJobs
